module.exports = __webpack_public_path__ + "static/media/400401_01.9ebe789d.png";